import { Api } from '../generated-api-types-account/Api'

export type AuthToken = string

// Nest klient pre /account doc (financie: bankové účty; budúce wallet/portfolio).
class ApiClientAccount {
  apiInstance: Api<AuthToken>

  constructor() {
    this.apiInstance = new Api<AuthToken>({
      baseUrl: `${import.meta.env.VITE_REACT_API2_HOST}`,
      baseApiParams: {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      },
      securityWorker: (token: AuthToken | null) => {
        return token
          ? {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          : {}
      },
    })
  }

  setAuthToken(newToken: string | null) {
    this.apiInstance.setSecurityData(newToken ? newToken : null)
  }
}

export default ApiClientAccount
